import React, { useId } from 'react';

interface FirefrontLogoProps {
  className?: string;
  size?: number;
}

export const FirefrontLogo: React.FC<FirefrontLogoProps> = ({
  className = 'logo',
  size = 32,
}) => {
  const uid = useId().replace(/:/g, '');
  const burningId = `burningGradient-${uid}`;
  const aliveId = `aliveGradient-${uid}`;
  const burnedId = `burnedGradient-${uid}`;

  return (
    <svg className={className} viewBox="0 0 200 200" width={size} height={size}>
      <defs>
        <linearGradient id={burningId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff4400" />
          <stop offset="100%" stopColor="#ff8c00" />
        </linearGradient>
        <linearGradient id={aliveId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3a7a33" />
          <stop offset="100%" stopColor="#2d5a27" />
        </linearGradient>
        <linearGradient id={burnedId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#393939" />
          <stop offset="100%" stopColor="#2a2a2a" />
        </linearGradient>
      </defs>

      <rect x="30" y="30" width="70" height="70" fill={`url(#${burningId})`} className="burning-tree">
        <animate attributeName="opacity" values="1;0.7;1" dur="0.5s" repeatCount="indefinite" />
      </rect>
      <rect x="100" y="30" width="70" height="70" fill={`url(#${aliveId})`} />
      <rect x="30" y="100" width="70" height="70" fill={`url(#${burnedId})`} />
      <rect x="100" y="100" width="70" height="70" fill={`url(#${burningId})`} className="burning-tree">
        <animate
          attributeName="opacity"
          values="1;0.7;1"
          dur="0.5s"
          repeatCount="indefinite"
          begin="0.25s"
        />
      </rect>
    </svg>
  );
};
